import { EquipmentDmgFilterType } from '@/entities/equipment';
import { TRepairServiceSchema } from '@/schemas/repair-service/repair-service.schema';
import requestApi, { HTTP_METHOD } from '@/utils/axios.http';
import { mapDmgFilterAPI } from '@/utils/map.utils';

const REPAIR_SERVICE_URI = '/repairService';

export const createNewRepairService = async (
  repairService: TRepairServiceSchema,
) => {
  return requestApi({
    url: REPAIR_SERVICE_URI,
    method: HTTP_METHOD.POST,
    body: repairService,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getExistingRepairService = async (
  query?: TRepairServiceSchema,
) => {
  let url = `${REPAIR_SERVICE_URI}/existing`;
  const params = new URLSearchParams();

  if (query?.id) {
    params.append('id', query.id);
  }

  if (query?.name) {
    params.append('name', query.name);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const listAllRepairServices = async () => {
  return requestApi({
    url: `${REPAIR_SERVICE_URI}/allRepairServices`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getAllRepairServices = async (
  filter: EquipmentDmgFilterType,
  page: number,
  limit: number,
  sortBy?: string,
  sortDirection?: 'asc' | 'desc',
) => {
  const filterMapped = mapDmgFilterAPI(filter);

  let url = `${REPAIR_SERVICE_URI}/all?${filterMapped}&page=${page}&limit=${limit}`;

  if (sortBy) {
    url += `&sortBy=${sortBy}&sortDirection=${sortDirection || 'asc'}`;
  }

  return requestApi({
    url: url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getRepairServiceById = async (id: string) => {
  return requestApi({
    url: `${REPAIR_SERVICE_URI}/${id}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getRepairServiceByName = async (name: string) => {
  return requestApi({
    url: `${REPAIR_SERVICE_URI}/byName/${name}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateRepairService = async (
  repairService: TRepairServiceSchema,
) => {
  return requestApi({
    url: `${REPAIR_SERVICE_URI}/update`,
    method: HTTP_METHOD.PATCH,
    body: repairService,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateManyRepairServices = async (
  repairServices: TRepairServiceSchema[],
) => {
  return requestApi({
    url: `${REPAIR_SERVICE_URI}/updateMany`,
    method: HTTP_METHOD.PATCH,
    body: repairServices,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
